// extracted by mini-css-extract-plugin
export default {"list-view-root":"ListPage_list-view-root__K4KYU","list-view-header":"ListPage_list-view-header__FrGxf","filter":"ListPage_filter__tiuEN"};